import React, {useContext} from 'react';
import {logoTextWhite} from '../../../assets/images';
import {EditorContext} from '../container/LessonEditorContainer';
import {
  LessonContentImageSource,
  LessonContentVideo,
} from '../../../data/models/LessonContent/LessonContentBase';
import {NodeData} from '../models';
import NodeHandles from './NodeHandles';

interface Props {
  data: NodeData;
}

const ImageSourceNode = ({data}: Props) => {
  const context = useContext(EditorContext);

  const onClick = (e: any) => {
    context.setSelectedNode(data.payload, data.type);
    e.stopPropagation();
  };

  return (
    <NodeHandles>
      <div>
        <div
          className={`EditorCard ${
            context.selectedNode?.internalId === data.payload.internalId
              ? 'SelectedEditorCard'
              : ''
          }`}
          onClick={onClick}>
          <p>{(data.payload as LessonContentVideo).title}</p>
          <div
            className={`PlaceholderContainer ${
              !(data.payload as LessonContentImageSource).contentUrl
                ? 'PlaceholderNoImage'
                : ''
            }`}>
            {(data.payload as LessonContentImageSource).contentUrl ? (
              <img
                src={(data.payload as LessonContentImageSource).contentUrl}
              />
            ) : (
              <img src={logoTextWhite} />
            )}
          </div>
        </div>
      </div>
    </NodeHandles>
  );
};

export default ImageSourceNode;
